// extracted by mini-css-extract-plugin
export default {"videoPreview":"video-component_videoPreview__2GCey","landscape":"video-component_landscape__4PrSU","portrait":"video-component_portrait__0chVB"};